import { createSelector } from 'reselect';

export const selectSubmitStatus = (state) =>
  state.employeeRegister?.submitStatus;

export const selectCivilData = (state) =>
  state.employeeRegister?.civilData?.data?.values || {};

export const selectCivilDataErrors = (state) =>
  state.employeeRegister?.civilData?.civilDataErrors || {};

export const selectCivilDataIsValidStatus = (state) =>
  state.employeeRegister?.civilData?.isValid;

export const selectSalarySituationData = (state) =>
  state.employeeRegister?.salarySituation?.data?.values || {};

export const selectSalarySituationErrors = (state) =>
  state.employeeRegister?.salarySituation?.salarySituationErrors || {};

export const selectSalarySituationIsValidStatus = (state) =>
  state.employeeRegister?.salarySituation?.isValid;

export const selectWorkContractData = (state) =>
  state.employeeRegister?.workContract?.data?.values || {};

export const selectWorkContractErrors = (state) =>
  state.employeeRegister?.workContract?.workContractErrors || {};

export const selectWorkContractIsValidStatus = (state) =>
  state.employeeRegister?.workContract?.isValid;

export const selectSpecialSituationsData = (state) =>
  state.employeeRegister?.specialSituations?.data?.values || {};

export const selectSpecialSituationsErrors = (state) =>
  state.employeeRegister?.specialSituations?.specialSituationsErrors || {};

export const selectSpecialSituationsIsValidStatus = (state) =>
  state.employeeRegister?.specialSituations?.isValid;

export const selectDocumentsData = (state) =>
  state.employeeRegister?.documents?.data?.values || {};

export const selectDocumentsErrors = (state) =>
  state.employeeRegister?.documents?.documentsErrors || {};

export const selectDocumentsUploadStatus = (state) =>
  state.employeeRegister?.documents?.uploadStatus;

const stepsKeys = [
  'civilData',
  'salarySituation',
  'workContract',
  'specialSituations',
  'documents',
];

export const selectProgress = createSelector(
  [(state) => state.employeeRegister],
  (employeeRegister) => {
    const stepsCount = stepsKeys.length;

    const totalProgress = stepsKeys.reduce((acc, key) => {
      const step = employeeRegister[key];
      const oneStepProgress = step?.data?.progress;

      if (step?.isValid && !step?.error) {
        return (
          acc + (oneStepProgress !== undefined ? oneStepProgress / 100 : 1)
        );
      }
      return acc;
    }, 0);

    return Math.ceil((totalProgress / stepsCount) * 100);
  }
);

export const selectFirst4TabsIsValidArray = createSelector(
  [
    selectCivilDataIsValidStatus,
    selectSalarySituationIsValidStatus,
    selectWorkContractIsValidStatus,
    selectSpecialSituationsIsValidStatus,
  ],
  (isTab1Valid, isTab2Valid, isTab3Valid, isTab4Valid) => [
    isTab1Valid,
    isTab2Valid,
    isTab3Valid,
    isTab4Valid,
  ]
);

export const selectFirst4TabsOverallStatus = createSelector(
  [selectFirst4TabsIsValidArray],
  (isValidArray) => !isValidArray.includes(false)
);
